import React from 'react';
import { Typography, Card, Row, Col, Steps, Alert } from 'antd';

const { Title, Paragraph, Text } = Typography;

const sectionStyle = { marginBottom: 24 };

const AccountDeletion = () => (
  <div style={{ padding: '40px 24px' }}>
    <Row justify="center">
      <Col xs={24} sm={20} md={18} lg={14}>
        <Card className="rounded-3xl shadow-lg" style={{ border: 'none' }}>
          <Title level={1}>Account Deletion</Title>
          <Paragraph>
            <Text type="secondary">Last updated: September 26, 2026</Text>
          </Paragraph>

          <Paragraph>
            You can delete your Current Care account and the personal data associated with it at
            any time. Once completed, you will not be able to log back in to that account, and
            your profile, chat history, and uploaded content will be removed.
          </Paragraph>

          <div style={sectionStyle}>
            <Title level={3}>How to delete your account</Title>
            <Steps
              direction="vertical"
              current={-1}
              size="small"
              items={[
                {
                  title: 'Open the Current Care app',
                  description: 'Make sure you are signed in to the account you want to delete.',
                },
                {
                  title: 'Go to Settings',
                  description: 'Open the left-hand menu (Profile) and tap the menu icon, then open Settings.',
                },
                {
                  title: 'Tap "Delete Account"',
                  description:
                    'A confirmation dialog will ask you to confirm. After you confirm, your account and data deletion request is processed.',
                },
              ]}
            />
          </div>

          <div style={sectionStyle}>
            <Alert
              type="info"
              showIcon
              message="What happens after deletion"
              description={
                <span>
                  We delete your account and associated personal data within 30 days. Certain
                  records (for example, transaction and tax records, or order history for
                  providers and delivery personnel) may be retained for as long as required by
                  law or our legitimate business requirements.
                </span>
              }
            />
          </div>

          <div style={sectionStyle}>
            <Title level={3}>Providers and delivery personnel</Title>
            <Paragraph>
              Accounts that hold order history must be retained for legal and tax purposes.
              If you are a provider or delivery partner and you no longer wish to use the app,
              please email{" "}
              <a href="mailto:support@currentcarenpl.com">support@currentcarenpl.com</a> from
              your registered email address to request assisted account deletion.
            </Paragraph>
          </div>

          <div style={sectionStyle}>
            <Title level={3}>Need help?</Title>
            <Paragraph>
              If you have trouble deleting your account in the app, email us at{" "}
              <a href="mailto:support@currentcarenpl.com">support@currentcarenpl.com</a> with
              the subject line "Account deletion request", and include the email address or phone
              number registered to your account.
            </Paragraph>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
);

export default AccountDeletion;